import { useFeature } from '@core/Utils/hooks/useFeature'

export const useIsBetLoopSportsFeatureActive = () => {
  const isBetLoopSportActive = useFeature('bet-loop-sports')

  return isBetLoopSportActive
}
